// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"2d8e6eea","400":"60b60bff","787":"6df47463"}[chunkId] + ".chunk.js";
};